import MakeAppointmentIcon from "assets/menu-icons/MakeAppointmentIcon";

const makeAppointment = {
  id: 'makeAppointment',
  type: 'group',
  children: [{
    id: 'makeAppointment',
    title: 'Запись на прием', 
    type: 'item',
    url: '/makeAppointment',
    icon: MakeAppointmentIcon,
    breadcrumbs: false
  }]
}

export default makeAppointment;